<template>
  <v-sheet
    v-if="currentPageName === 'project'"
    :color="backgroundColor"
  >
    <report-container
      v-if="reportPath !== 'profile'"
      :actions="actions"
    >
      <template v-slot:report-modals>
        <project-modal />
      </template>
    </report-container>

    <project-profile v-else />
  </v-sheet>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import mixin from 'src/utils/mixin'

const { mapGetters: mapAuthGetters } = createNamespacedHelpers('auth')
const { mapGetters: mapLayoutGetters } = createNamespacedHelpers('layout')

export default {
  name: 'Project',
  components: {
    ProjectModal: () => import('src/internal/components/ProjectModal'),
    ProjectProfile: () => import('src/internal/components/ProjectProfile'),
    ReportContainer: () => import('src/report/components/ReportContainer'),
  },
  mixins: [mixin],
  computed: {
    ...mapAuthGetters([
      'isInternalAdminUser',
    ]),
    ...mapLayoutGetters([
      'backgroundColor',
    ]),
    actions() {
      const adminActions = [
        {
          event: 'tools/updateRoute',
          name: 'View Details',
        },
        {
          event: 'internal/showFormProjectUpdate',
          name: 'Edit',
        },
        {
          event: 'internal/showFormProjectDelete',
          name: 'Delete',
        },
      ]

      return this.isInternalAdminUser ? adminActions : []
    },
  },
}
</script>
